import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder1 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "../../../constants/PropCategories";
import {
  getMarginOptions,
  getPaddingOptions,
} from "../../../utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "../../../utils/buttonStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";
import { createUserCardBlock } from "../../utils/layoutBlockHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import { createPBlock } from "../../utils/textBlocksHelpers";
import starsImagePlaceholder from "./stars_image_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "Testimonial2",
  meta: {},
  props: {
    image: {
      meta: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: starsImagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "7.25rem",
                width: "auto",
                height: "auto",
                minHeight: "none",
                minWidth: "none",
              },
            }),
          },
        }),
      ],
    },
    userCard: {
      meta: {
        name: "User Card",
        nameI18n: "builder_ui.prop_type.user_card",
      },
      prop: "children",
      type: "children",
      value: [
        createUserCardBlock({
          image: {
            signedId: "",
            placeholder: userImagePlaceholder1,
          },
          header: "Aisha Meher",
          description: "Non-Profit Leader",
        }),
      ],
    },
    content: {
      meta: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
      },
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: '"This program gave me the confidence to step into a leadership role I would have previously thought was beyond my capabilities. Life changing!"',
          paragraphStyle: "p2",
        }),
      ],
    },
  },
};

export const createTestimonial2Block = ({
  image = { signedId: "", placeholder: starsImagePlaceholder },
  userCard = { signedId: "", placeholder: "", header: "", description: "" },
  content = "",
}: {
  image?: {
    signedId: string;
    placeholder: string;
  };
  userCard?: {
    signedId: string;
    placeholder: string;
    header: string;
    description: string;
  };
  content?: string;
}): BaseBlock => ({
  ...defaultData,
  id: uuidv4(),
  props: {
    ...defaultData.props,
    image: {
      ...defaultData.props.image,
      type: "children",
      prop: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "7.25rem",
                width: "auto",
                height: "auto",
                minHeight: "none",
                minWidth: "none",
              },
            }),
          },
        }),
      ],
    },
    userCard: {
      ...defaultData.props.userCard,
      type: "children",
      prop: "children",
      value: [
        createUserCardBlock({
          image: {
            signedId: userCard.signedId,
            placeholder: userCard.placeholder,
          },
          header: userCard.header,
          description: userCard.description,
        }),
      ],
    },
    content: {
      ...defaultData.props.content,
      type: "children",
      prop: "children",
      value: [
        createPBlock({
          text: content,
          paragraphStyle: "p2",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        }),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "32",
            paddingRight: "32",
            paddingBottom: "32",
            paddingLeft: "32",
          },
          category: [DesignProp, PaddingsProp],
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
          category: [DesignProp, MarginsProp],
        }),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
});
